import moment from 'moment';
import { isRequired } from './isRequired';
import { FORMAT_DATE_FR } from '../date';
import { and, isNil } from 'ramda';

const FUTURE_DATE_MESSAGE =
  'Vous ne pouvez pas sélectionner une date dans le futur.';

export const parseDate = (date) => {
  if (moment.isMoment(date)) return date;

  if (date instanceof Date) return moment(date);

  if (typeof date === 'string') {
    const frFormat = moment(date, 'DD/MM/YYYY', true);
    if (frFormat.isValid()) return frFormat;
    return moment(date, moment.ISO_8601, true);
  }

  return moment.invalid();
};

export const dateIsCorrectlyBefore = (dateToCompare, message, mandatory = true) => {
  if (isNil(dateToCompare)) {
    return isRequired;
  }
  const max = parseDate(dateToCompare);
  return {
    ...(mandatory ? { required: isRequired } : null),
    validate: (date) => {
      const d = parseDate(date);
      if (!d.isValid()) return 'Date invalide';
      return (
        d.isSameOrBefore(max, 'day') ||
        message ||
        'La date de naissance est invalide. L’âge à la date d’effet du contrat doit être au minimum de 18 ans'
      );
    }
  };
};

export const dateIsCorrectlyAfter = (dateToCompare, message, mandatory = true) => {
  if (isNil(dateToCompare)) {
    return isRequired;
  }

  const min = parseDate(dateToCompare);

  return {
    ...(mandatory ? { required: isRequired } : null),
    validate: (date) => {
      const d = parseDate(date);

      if (!d.isValid()) return 'Date invalide';

      return (
        d.isSameOrAfter(min, 'day') ||
        message ||
        'La date de naissance est invalide. L’âge à la date d’effet du contrat doit être compris entre 0 et 28 ans'
      );
    }
  };
};

export const dateIsBetween = (minDate, maxDate, message, mandatory = true) => {
  const min = parseDate(minDate);
  const max = parseDate(maxDate);

  return {
    ...(mandatory ? { required: isRequired } : null),
    validate: (date) => {
      const d = parseDate(date);

      if (!d.isValid()) return 'Date invalide';

      return (
        d.isSameOrAfter(min, 'day') &&
        d.isSameOrBefore(max, 'day') ||
        message ||
        `La date doit être comprise entre le ${min.format(FORMAT_DATE_FR)} et le ${max.format(FORMAT_DATE_FR)}`
      );
    }
  };
};

export const dateHasConstraints = (
  minDate,
  maxDate,
  messageMin,
  messageMax,
  messageAll,
  mandatory = true
) => {
  const min = minDate ? parseDate(minDate) : null;
  const max = maxDate ? parseDate(maxDate) : null;

  return {
    ...(mandatory ? { required: isRequired } : null),

    validate: (date) => {
      const d = parseDate(date);

      if (!d.isValid()) return 'Date invalide';

      const today = moment().endOf('day');

      if (d.isAfter(today, 'day')) {
        return FUTURE_DATE_MESSAGE;
      }

      if (
        min &&
        max &&
        max.isSame(moment(), 'day') &&
        d.isBefore(min, 'day')
      ) {
        return messageMax;
      }

      // MIN + MAX
      if (and(min, max)) {
        return dateIsBetween(min, max, messageAll, mandatory).validate(d);
      }

      // MIN ONLY
      else if (min) {
        return dateIsCorrectlyAfter(min, messageMax, mandatory).validate(d);
      }

      // MAX ONLY
      else if (max) {
        return dateIsCorrectlyBefore(max, messageMin, mandatory).validate(d);
      }

      return true;
    }
  };
};
